import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import AgentListDocumentOptionItem from '../../../RunPay/Admin/IServices/Models/AgentTypeDocumentOption/AgentListDocumentOptionItem';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';

export default class AgentListDocumentOptionService {
	webApiService: WebApiService;
	DeleteEvent = new Events<WsResponseModel<Boolean>>();
	GetListEvent = new Events<WsResponseModel<Array<AgentListDocumentOptionItem>>>();
	SaveEvent = new Events<WsResponseModel<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('AgentListDocumentOptionService', 'Delete', (res: WsResponseModel<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('AgentListDocumentOptionService', 'GetList', (res: WsResponseModel<Array<AgentListDocumentOptionItem>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('AgentListDocumentOptionService', 'Save', (res: WsResponseModel<Boolean>) => {
			self.SaveEvent.trigger(res);
		});
	}
	Delete(key?: string = '') { 	
        this.webApiService.send('AgentListDocumentOptionService', 'Delete' , key);
    }
	GetList() { 	
        this.webApiService.send('AgentListDocumentOptionService', 'GetList' );
    }
	Save(request: AgentListDocumentOptionItem = null) { 	
        this.webApiService.send('AgentListDocumentOptionService', 'Save' , request);
    }
	 // async methods
	async deleteAsync(key: string = ''): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(key);
	}
	async getListAsync(): Promise<Array<AgentListDocumentOptionItem>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)();
	}
	async saveAsync(request: AgentListDocumentOptionItem = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Save.bind(this), this.SaveEvent)(request);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/AgentListDocumentOptionService.ts